<template>
  <div>
    <a-drawer title="批量上传素材" :width="720" :visible="showBatchUpload" :body-style="{ paddingBottom: '80px' }"
      :mask-closable="false" @close="close">

      <a-form-model layout="inline" style="margin-bottom: 16px;">
        <a-form-model-item label="目录" required>
          <a-tree-select v-model="pid" style="width: 240px" placeholder="选择目录" allow-clear :tree-data="treeData"
            :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" />
        </a-form-model-item>
        <a-form-model-item label="上传人" required>
          <a-select v-model="workerId" style="width: 160px" placeholder="选择上传人" allow-clear show-search
            option-filter-prop="children">
            <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
              {{ worker.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>

      <!-- 拖拽上传区域 -->
      <a-upload-dragger :before-upload="beforeUpload" :show-upload-list="false" :multiple="true"
        accept="video/*,.mp4,.avi,.mov,.wmv,image/*,.jpg,.jpeg,.png,.gif">
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">拖拽文件到此处，或点击选择文件</p>
        <p class="ant-upload-hint">支持 mp4/avi/mov/wmv/jpg/png/gif，单个视频 ≤ 2GB</p>
      </a-upload-dragger>

      <!-- 上传队列 -->
      <div v-if="uploadQueue.length > 0" style="margin-top: 16px;">
        <a-divider>上传队列 ({{ completedCount }}/{{ uploadQueue.length }})</a-divider>
        <div v-for="(item, index) in uploadQueue" :key="item.uid" class="batch-upload-item">
          <div class="batch-upload-item-header">
            <a-icon :type="item.status === 'success' ? 'check-circle' : item.status === 'error' ? 'close-circle' : 'loading'"
              :style="{ color: item.status === 'success' ? '#52c41a' : item.status === 'error' ? '#ff4d4f' : '#1890ff' }" />
            <span class="batch-upload-item-name">{{ item.name }}</span>
            <span class="batch-upload-item-size">{{ formatSize(item.size) }}</span>
            <a-button v-if="item.status === 'error'" type="link" size="small" @click="retryUpload(index)">
              重试
            </a-button>
            <a-button v-if="item.status !== 'uploading' && item.status !== 'pending'" type="link" size="small"
              @click="removeFromQueue(index)">
              移除
            </a-button>
          </div>
          <a-progress :percent="item.percent" :status="item.status === 'error' ? 'exception' : item.status === 'success' ? 'success' : 'active'"
            :format="() => item.status === 'success' ? '完成' : item.status === 'error' ? '失败' : `${item.percent}%`" />
          <div v-if="item.retryHint" class="batch-upload-retry-hint">{{ item.retryHint }}</div>
          <div v-if="item.status === 'success' && item.materialId" class="batch-upload-material-id">
            素材ID: {{ item.materialId }}
          </div>
        </div>
      </div>

      <div :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }">
        <a-button @click="close">关闭</a-button>
      </div>

    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
.batch-upload-item {
  margin-bottom: 12px;
  padding: 8px 12px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  background: #fafafa;
}

.batch-upload-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  gap: 8px;
}

.batch-upload-item-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}

.batch-upload-item-size {
  color: #999;
  font-size: 12px;
  white-space: nowrap;
}

.batch-upload-retry-hint {
  font-size: 12px;
  color: #faad14;
  margin-top: 2px;
}

.batch-upload-material-id {
  font-size: 12px;
  color: #52c41a;
  margin-top: 2px;
}
</style>

<script>
import BatchUpload from './BatchUpload'
export default BatchUpload
</script>
